import axios from "axios";
import {get_default_headers} from "./requests";
import {joinUrls} from "./funclib";
import store from '@/store';
// import {Card} from "./models/Card";

export function apiClient() {
    return axios.create({
        baseURL: store.state.apiBaseUrl,
        withCredentials: false, // This is the default
        headers: get_default_headers(),
        timeout: 10000
    });
}

export const STATUS_NEW = 'N';
export const STATUS_CHANGED = 'C';
export const STATUS_DELETED = 'D';

class ApiBase {
    parent;
    getLoaded = false;
    url;
    pkAttribute = 'id';
    pkRegExp = new RegExp(":pk");
    modelFields = [];
    dateFields = [];
    updateFields = [];
    ignoreFields = [];
    status;

    constructor(parent) {
        this.parent = parent;
    }
    getUrl(pk, url) {
        if (!url) {
            url = this.url;
        }
        if (url.search(this.pkRegExp))
            return url.replace(this.pkRegExp, pk);
        return joinUrls(url, pk)
    }
    getModelFields () {
        if (!this.modelFields.length) {
            this.modelFields = [];
            for (let attr in this.parent) {
                // console.log('Attr:', attr);
                if (attr !== 'api' && this.ignoreFields.indexOf(attr) === -1 && attr.substring(0, 1) !== '_')
                    this.modelFields.push(attr);
            }
        }
        return this.modelFields;
    }
    getData () {
        let data = {};
        for (let field of this.getModelFields()) {
            data[field] = this.parent[field];
        }
        return data;
    }
    getPayload(fields) {
        let payload = {};
        if (!fields) {
            fields = this.updateFields;
        }
        for (let field of fields) {
            let dbField = field.replace(/([A-Z])/g, function($1){return "_"+$1.toLowerCase();});
            // eslint-disable-next-line no-console
            // console.log(field, db_field);
            if (this.parent[field] instanceof Object && this.parent[field].id) {
                payload[dbField] = this.parent[field].id;
            } else {
                payload[dbField] = this.parent[field];
            }
        }
        // eslint-disable-next-line no-console
        // console.log(payload);
        return payload;
    }
    fetch(pk, url) {
        return this.fetchUrl(this.getUrl(pk, url))
    }
    fetchUrl(url) {
        this.getLoaded = false;
        // let that = this;
        return apiClient().get(url).then(response => {
            this.parent.modelCopy(response.data);
            this.getLoaded = true;
        })
    }
    save(fields) {
        return apiClient().patch(this.getUrl(this.parent[this.pkAttribute]), this.getPayload(fields));
    }
    create() {
        return apiClient().post(this.getUrl(''), this.getPayload())
    }
    delete () {
        let that = this;
        return apiClient().delete(this.getUrl(this.parent[this.pkAttribute])).then(function () {
            that.status = STATUS_DELETED;
        })
    }
}

export class ApiDetail extends ApiBase {
}

export class ApiList extends ApiBase {
    getUrl(pk, url) {
        if (!url) {
            url = this.url
        }
        if (pk)
            return url.replace(this.pkRegExp, pk);
        return url;
    }
}

export class BaseModel {
    api = new ApiDetail(this);

    constructor(data, status) {
        if (data) {
            this.modelCopy(data);
        }
        if (status) {
            this.api.status = status;
        }
    }
    instantiateModel(klass, property) {
        if (this[property] instanceof Object) {
            this[property] = new klass(this[property]);
        }
    }
    instantiateModelList(klass, property) {
        if (this[property] instanceof Array) {
            let list = this[property];
            this[property] = [];
            for (let item of list) {
                this[property].push(new klass(item));
            }
        }
    }
    modelCopy(data) {
        if (data instanceof Object) {
            let fieldNames = this.api.getModelFields();
            for (let attr in data) {
                if  (attr !== 'api' && attr.substring(0, 1) !== '_') {
                    let ccAttr = attr.replace(
                        /(_\w)/g,
                        function (match) { return match[1].toUpperCase() }
                    );
                    if (fieldNames.indexOf(ccAttr) >= 0) {
                        this[ccAttr] = data[attr];
                    } else {
                        // eslint-disable-next-line no-console
                        console.log(this.constructor.name, 'class has no attribute:', ccAttr);
                    }
                }
            }
            for (let key of this.api.dateFields) {
                if (!(this[key] instanceof Date))
                    this[key] = new Date(this[key])
            }
        }
    }
}


export class BaseChangeStampModel extends BaseModel {
    createdBy;
    createdDate;
    modifiedBy;
    modifiedDate;

}
export class BaseListModel extends BaseModel {
    api = new ApiList(this);
    list = [];
    _class = null;

    modelCopy(items) {
        if (items instanceof Array) {
            this.list = [];
            for (let item of items) {
                if(this._class) {
                    this.list.push(new this._class(item))
                } else {
                    this.pushItem(item);
                }
            }
        }
    }
    pushItem(item) {
        this.list.push(item);
    }
}
